<div class="product-view-details-modal">
 
  <!-- Header -->
  <div class="product-view-details-header">
    <h2>Return product details</h2>
 
    <button
      type="button"
      class="close-icon"
      (click)="closeModal()"
      aria-label="Close"
    >
      ×
    </button>
  </div>
 
  <!-- Product Table -->
  <div class="product-table-wrapper">
 
    <table class="product-table">
 
      <thead>
        <tr>
          <th></th>
          <th>Serial Number</th>
          <th>Part Number</th>
          <th>Product Name &amp; Description</th>
          <th>Order #</th>
          <th>Sold To</th>
        </tr>
      </thead>
 
      <tbody>
        <tr>
 
          <!-- Product Image -->
          <td class="product-image-cell">
            <cx-media
      class="confirm-product-img"
      [container]="product?.images"
      format="product"
      [alt]="product?.images?.[0]?.altText">
    </cx-media>
          </td>
 
          <!-- Serial Number -->
          <td>
            {{ product?.serialNumber }}
          </td>
 
          <!-- Part Number -->
          <td>
            {{ product?.partNumber }}
          </td>
 
          <!-- Product Name & Description -->
          <td class="product-description-cell">
 
 <strong>
            <div class="product-description">
              {{ product?.partDescription }}
            </div>
 </strong>
          </td>
 
          <!-- Order Number -->
          <td>
            {{ product?.orderId }}
          </td>
 
          <!-- Sold To -->
          <td class="sold-to-cell">
 <strong>
            <div>
              {{ product?.soldToAddress }}
            </div>
 </strong>
 
          </td>
 
        </tr>
      </tbody>
 
    </table>
 
  </div>
 
  <!-- Footer -->
  <div class="product-view-details-footer">
 
    <bh-button
      type="primary"
      label="Close"
      (click)="closeModal()"
    >
    </bh-button>
 
  </div>
 
</div>